import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PageNotfoundComponent } from './Erros/page-notfound/page-notfound.component';
import { MainPageComponent } from './Home/mainpage/mainpage.component';
import { LoginComponent } from './Home/login/login.component';


const routes = [
  { path: '', component: LoginComponent },
  { path: 'cockpittop', component: MainPageComponent },
  { path: '**', component: PageNotfoundComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
